export const ChatIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <path d="M18 5H23V23L19.2222 19.2222H6V15.5M6 6H13M6 10H13M1 1H18V15.2222H4.77778L1 19V1Z" />
      </g>
    </svg>
  );
};
